module.exports = __webpack_public_path__ + "img/plus.0edd3baa.svg";